import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "../services/app.service";
import { AuthService } from "../services/auth.service";

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
    const appService = inject(AppService);
    const translate = inject(TranslateService);
    const authService = inject(AuthService);
    const authorized = authService.isAuthorized(route.data['expectedPermissions'])()
    if (!authorized) {
        appService.showMsg(translate.instant('noPermission'), 'error');
    }
    return authorized;
}